/* eslint-disable prettier/prettier */
import React, { useEffect, useMemo, useState } from 'react';
import styles from '../../../styles/components/pageComponents/program/EditProgramOwner.module.css';
import SearchableDropdown from '../../controlVariations/SearchableDropdown';
import SearchableMultiSelectDropdown from '../../controlVariations/SearchableMultiselectDropdown';
import { useCreateCourse } from '../../../hooks/useCourse';
import { CreateCourseRequest, FacultyRole } from '../../../types/course';
import { useUsers } from '../../../hooks/useAllUsers';
import { useUpdateCourse } from '../../../hooks/useUpdateCourse';
import { useCoachManagement } from '../../../hooks/useCourse';

interface EditProgramOwnerProps {
	course?: any;
	onCancel: () => void;
	onSaveSuccess?: () => void;
}

// --- Reusable SVG Icons ---
const TrashIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="20"
		height="22"
		viewBox="0 0 20 22"
		fill="none"
	>
		<path
			d="M7.75 9.75V15.75M11.75 9.75V15.75M16.75 4.75V18.75C16.75 19.2804 16.5393 19.7891 16.1642 20.1642C15.7891 20.5393 15.2804 20.75 14.75 20.75H4.75C4.21957 20.75 3.71086 20.5393 3.33579 20.1642C2.96071 19.7891 2.75 19.2804 2.75 18.75V4.75M0.75 4.75H18.75M5.75 4.75V2.75C5.75 2.21957 5.96071 1.71086 6.33579 1.33579C6.71086 0.960714 7.21957 0.75 7.75 0.75H11.75C12.2804 0.75 12.7891 0.960714 13.1642 1.33579C13.5393 1.71086 13.75 2.21957 13.75 2.75V4.75"
			stroke="#6B7280"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

const InfoIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="27"
		height="27"
		viewBox="0 0 27 27"
		fill="none"
	>
		<path
			d="M13.25 18.25V13.25M13.25 8.25H13.2625M25.75 13.25C25.75 20.1536 20.1536 25.75 13.25 25.75C6.34644 25.75 0.75 20.1536 0.75 13.25C0.75 6.34644 6.34644 0.75 13.25 0.75C20.1536 0.75 25.75 6.34644 25.75 13.25Z"
			stroke="#147B58"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

const OwnerIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="27"
		height="27"
		viewBox="0 0 27 27"
		fill="none"
	>
		<path
			d="M20.75 23.25C20.75 21.2609 19.9598 19.3532 18.5533 17.9467C17.1468 16.5402 15.2391 15.75 13.25 15.75M13.25 15.75C11.2609 15.75 9.35322 16.5402 7.9467 17.9467C6.54018 19.3532 5.75 21.2609 5.75 23.25M13.25 15.75C16.0114 15.75 18.25 13.5114 18.25 10.75C18.25 7.98858 16.0114 5.75 13.25 5.75C10.4886 5.75 8.25 7.98858 8.25 10.75C8.25 13.5114 10.4886 15.75 13.25 15.75ZM25.75 13.25C25.75 20.1536 20.1536 25.75 13.25 25.75C6.34644 25.75 0.75 20.1536 0.75 13.25C0.75 6.34644 6.34644 0.75 13.25 0.75C20.1536 0.75 25.75 6.34644 25.75 13.25Z"
			stroke="#147B58"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

const FacultyIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="22"
		height="21"
		viewBox="0 0 22 21"
		fill="none"
	>
		<path
			d="M0.75 18.75C0.749916 17.2103 1.19413 15.7033 2.02935 14.4099C2.86456 13.1164 4.05527 12.0915 5.4586 11.458C6.86193 10.8246 8.41824 10.6095 9.94076 10.8387C11.4633 11.0678 12.8873 11.7315 14.042 12.75M17.75 13.75V19.75M20.75 16.75H14.75M13.75 5.75C13.75 8.51142 11.5114 10.75 8.75 10.75C5.98858 10.75 3.75 8.51142 3.75 5.75C3.75 2.98858 5.98858 0.75 8.75 0.75C11.5114 0.75 13.75 2.98858 13.75 5.75Z"
			stroke="#147B58"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

const FormatIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="27"
		viewBox="0 0 24 27"
		fill="none"
	>
		<path
			d="M7 0.75V5.75M17 0.75V5.75M0.75 10.75H23.25M7 15.75H7.0125M12 15.75H12.0125M17 15.75H17.0125M7 20.75H7.0125M12 20.75H12.0125M17 20.75H17.0125M3.25 3.25H20.75C22.1307 3.25 23.25 4.36929 23.25 5.75V23.25C23.25 24.6307 22.1307 25.75 20.75 25.75H3.25C1.86929 25.75 0.75 24.6307 0.75 23.25V5.75C0.75 4.36929 1.86929 3.25 3.25 3.25Z"
			stroke="#147B58"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

const CertificationIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="27"
		height="27"
		viewBox="0 0 27 27"
		fill="none"
	>
		<path
			d="M10.75 16.575V18.6075C10.7453 19.0358 10.6306 19.4557 10.417 19.8269C10.2033 20.1981 9.89792 20.5082 9.53 20.7275C8.74893 21.306 8.11355 22.0587 7.67436 22.9258C7.23516 23.7929 7.00426 24.7505 7 25.7225M15.75 16.575V18.6075C15.7547 19.0358 15.8694 19.4557 16.083 19.8269C16.2967 20.1981 16.6021 20.5082 16.97 20.7275C17.7511 21.306 18.3864 22.0587 18.8256 22.9258C19.2648 23.7929 19.4957 24.7505 19.5 25.7225M20.75 9.5H22.625C23.4538 9.5 24.2487 9.17076 24.8347 8.58471C25.4208 7.99866 25.75 7.2038 25.75 6.375C25.75 5.5462 25.4208 4.75134 24.8347 4.16529C24.2487 3.57924 23.4538 3.25 22.625 3.25H20.75M20.75 9.5C20.75 11.4891 19.9598 13.3968 18.5533 14.8033C17.1468 16.2098 15.2391 17 13.25 17C11.2609 17 9.35322 16.2098 7.9467 14.8033C6.54018 13.3968 5.75 11.4891 5.75 9.5M20.75 9.5V2C20.75 1.66848 20.6183 1.35054 20.3839 1.11612C20.1495 0.881696 19.8315 0.75 19.5 0.75H7C6.66848 0.75 6.35054 0.881696 6.11612 1.11612C5.8817 1.35054 5.75 1.66848 5.75 2V9.5M3.25 25.75H23.25M5.75 9.5H3.875C3.0462 9.5 2.25134 9.17076 1.66529 8.58471C1.07924 7.99866 0.75 7.2038 0.75 6.375C0.75 5.5462 1.07924 4.75134 1.66529 4.16529C2.25134 3.57924 3.0462 3.25 3.875 3.25H5.75"
			stroke="#147B58"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);


const EditProgramOwner: React.FC<EditProgramOwnerProps> = ({ onCancel, onSaveSuccess, course }) => {
	const DEFAULT_ROLE = 'faculty' as unknown as FacultyRole;
	const [formData, setFormData] = useState<Record<string, string>>({});
	const [selectedFaculty, setSelectedFaculty] = useState<string[]>([]);
	const { createCourse } = useCreateCourse();
	const { updateCourse } = useUpdateCourse();

	const { coaches, admins, fetchCoaches, fetchAdminAndSuperAdmins } =
		useUsers();

	const { addCoach, removeCoach } = useCoachManagement();

	useEffect(() => {
		console.log("FORM DATA", formData);
	}, [formData]);

	useEffect(() => {
		if (!course) return;

		console.log("FACULTY", course.faculty);

		console.log(
			"COURSE FACULTY FULL",
			JSON.stringify(course.faculty, null, 2)
		);

		console.log(
			"COURSE COACHES FULL",
			JSON.stringify(course.coaches, null, 2)
		);
		console.log("COACHES", course.coaches);

		console.log("COURSE KEYS", Object.keys(course));
		console.log("COURSE", course);

		console.log(
			'COURSE FACULTY',
			course.faculty?.map((f: any) => ({
				userid: f.userid,
				fullname: f.fullname,
			}))
		);

		console.log(
			'COURSE COACHES',
			course.coaches
		);

		console.log("programownerid", course?.programownerid);
		console.log("programformat", course?.programformat);
		console.log("certification", course?.certification);
		console.log("facultyids", course?.facultyids);

		console.log("STEP 1 → COURSE OBJECT:", course);
		console.log("STEP 1 → FACULTY FROM API:", course.facultyids);
		setFormData({
			owner: course.programownerid || '',
			format: course.programformat || '',
			certification: course.certification || '',
		});

		// Optional: if faculty exists in API
		if (course.faculty?.length) {

			console.log(
				'BEFORE PRESELECTED IDS',
				course.faculty.map((f: any) => f.userid)
			);
			setSelectedFaculty(
				course.faculty.map((f: any) => f.userid)
			);

			console.log(
				'AFTER PRESELECTED IDS',
				course.faculty.map((f: any) => f.userid)
			);
		}
	}, [course]);

	useEffect(() => {
		fetchCoaches('coach');
		fetchAdminAndSuperAdmins();
	}, []);


	const allUsersOptions = useMemo(
		() => [
			...admins.map(u => ({
				label: `${u.fullname} (${u.rolename})`,
				value: u.id,
			})),
			...coaches.map(u => ({
				label: `${u.fullname} (${u.rolename || 'coach'})`,
				value: u.id,
			})),
		],
		[admins, coaches]
	);
	const allUserLabels = allUsersOptions.map(u => u.label);

	const handleInputChange = (id: string, value: string) => {
		setFormData(prev => ({ ...prev, [id]: value }));
	};


	const handleSave = async () => {
		try {
			const hasExistingCourse = !!course?.id;

			// 🔥 COMMON DATA (what user edited)
			const updatedFields = {
				programownerid: formData['owner'],
				programformat: formData['format'],
				certification: formData['certification'],
				facultyids: selectedFaculty.map((id, index) => ({
					userid: id,
					facultyrole: DEFAULT_ROLE,
					displayorder: index,
				})),
			};

			if (hasExistingCourse) {
				const payload = {
					programownerid: updatedFields.programownerid,
					programformat: updatedFields.programformat,
					certification: updatedFields.certification,
					facultyids: updatedFields.facultyids,
				};

				console.log('CLEAN UPDATE PAYLOAD', payload);

				await updateCourse(course.id, payload);
			} else {
				// =========================
				// ✅ CREATE FLOW
				// =========================
				const payload: CreateCourseRequest = {
					title: formData['title'] || 'Untitled Program',
					description: formData['description'] || '',
					coursetype: 'standard',
					deliverymode: 'hybrid',
					difficulty: 'beginner',
					category: formData['category'] || 'standard',
					solutionid: formData['solution'],
					programincludes: [],
					learningtakeaways: [],
					programformat: updatedFields.programformat,
					certification: updatedFields.certification,
					facultyids: updatedFields.facultyids,
					programownerid: updatedFields.programownerid,
					status: 'published',
					ispublic: true,
				};

				console.log('CREATE PAYLOAD', payload);

				await createCourse(payload);
			}

			onSaveSuccess?.();
			onCancel();
		} catch (err) {
			console.error(err);
		}
	};

	const fieldsConfig = [
		{
			id: 'owner',
			label: 'Program Owner',
			subLabel: 'Program Owner will have edit access to the program',
			placeholder: 'Select Program Owner',
			Icon: OwnerIcon,
		},
		{
			id: 'faculty',
			label: 'Program Faculty',
			subLabel: 'Coaches contributing to the program',
			placeholder: 'Select Coaches',
			Icon: FacultyIcon,
		},
		{
			id: 'format',
			label: 'Program Format',
			subLabel: 'Number of activities and events',
			placeholder: 'Add Program Format',
			Icon: FormatIcon,
		},
		{
			id: 'certification',
			label: 'Certification',
			subLabel: 'Details of certification',
			placeholder:
				'ICF Level 1 accredited Executive Coaching Certification',
			Icon: CertificationIcon,
		},
	];

	useEffect(() => {
		if (!course || !allUsersOptions.length) return;

		if (course.faculty?.length) {
			const ids = course.faculty.map((f: any) => f.userid);

			console.log("SETTING FACULTY IDS", ids);

			setSelectedFaculty(ids);
		}
	}, [course, allUsersOptions]);

	return (
		<div className={styles.modalOverlay}>
			<div className={styles.modalContent}>
				{/* Header */}
				<div className={styles.header}>
					<h2 className={styles.title}>
						Update Program Details - Owner And Faculty
					</h2>
					<div className={styles.actionButtons}>
						<button className={styles.btnCancel} onClick={onCancel}>
							Cancel
						</button>
						<button className={styles.btnSave} onClick={handleSave}>
							Save Changes
						</button>
					</div>
				</div>

				{/* Body - New Target Styling */}
				<div className={styles.infoLayoutContainer}>
					{/* Left Column: Descriptions & Labels */}
					<div className={styles.descriptionColumn}>
						<div className={styles.infoTitle}>
							<span className={styles.infoIcon}>
								<InfoIcon />
							</span>
							<div className={styles.titleDividerCont}>
								Info{' '}
								<span
									className={styles.titleDividerLine}
								></span>
							</div>
						</div>

						{fieldsConfig.map(field => (
							<div key={field.id} className={styles.textBlock}>
								<h4 className={styles.blockLabel}>
									{field.label}
								</h4>
								<p className={styles.blockSubLabel}>
									{field.subLabel}
								</p>
							</div>
						))}
					</div>

					{/* Right Column: Inputs & Shaded Background */}
					<div className={styles.inputColumnShaded}>
						{fieldsConfig.map(field => (
							<div
								key={field.id}
								className={styles.shadedFieldRow}
							>
								<div className={styles.shadedLabelRow}>
									<span className={styles.iconPlaceholder}>
										<field.Icon />
									</span>
									<label>{field.label}</label>
									{/* <button className={styles.deleteBtn}><TrashIcon /></button> */}
								</div>

								{/* Dynamic Inputs based on ID */}
								{field.id === 'owner' && (
									<SearchableDropdown
										placeholder={field.placeholder}
										options={allUserLabels}
										selected={
											allUsersOptions.find(
												o =>
													o.value ===
													formData['owner']
											)?.label
										}
										onSelect={label => {
											const selected =
												allUsersOptions.find(
													o => o.label === label
												);
											if (selected) {
												handleInputChange(
													'owner',
													selected.value
												);
											}
										}}
									/>
								)}

								{field.id === 'faculty' && (
									<SearchableMultiSelectDropdown
										placeholder={field.placeholder}
										options={allUserLabels}
										selected={selectedFaculty.map(
											id =>
												allUsersOptions.find(
													o => o.value === id
												)?.label || ''
										)}
										onChange={async labels => {
											if (!course?.id) return;

											const newIds = labels
												.map(
													label =>
														allUsersOptions.find(
															o => o.label === label
														)?.value
												)
												.filter(Boolean) as string[];

											// newly selected faculty
											const addedIds = newIds.filter(
												id => !selectedFaculty.includes(id)
											);

											// unticked faculty
											const removedIds = selectedFaculty.filter(
												id => !newIds.includes(id)
											);

											try {
												// Add newly selected faculty
												for (const coachId of addedIds) {
													await addCoach(course.id, {
														userid: coachId,
													});
												}

												// Remove unticked faculty
												for (const coachId of removedIds) {

													console.log("========== REMOVE ==========");
													console.log("PROGRAM ID:", course.id);
													console.log("COACH ID:", coachId);
													console.log(
														"SELECTED FACULTY:",
														JSON.stringify(selectedFaculty, null, 2)
													);
													console.log(
														"NEW IDS:",
														JSON.stringify(newIds, null, 2)
													);
													await removeCoach(course.id, coachId);
												}

												setSelectedFaculty(newIds);
											} catch (error) {
												console.error('Faculty update failed', error);
											}
										}}
									/>
								)}

								{field.id !== 'owner' &&
									field.id !== 'faculty' && (
										<input
											type="text"
											className={styles.shadedInput}
											placeholder={field.placeholder}
											value={formData[field.id] || ''}
											onChange={e =>
												handleInputChange(
													field.id,
													e.target.value
												)
											}
										/>
									)}
							</div>
						))}
					</div>
				</div>
			</div>
		</div>
	);
};

export default EditProgramOwner;
